enum HabitType {
  SLIDER = 'slider',
  RADIO = 'radio',
  INPUT = 'input',
}

export default HabitType;
